import React, { useState, useEffect } from "react";
import "../styles/Modal.css";

interface LayoutSettingsModalProps {
  isOpen: boolean;
  showClassMaterials: boolean;
  showAllLanguages: boolean;
  onClose: () => void;
  onSave: (showClassMaterials: boolean, showAllLanguages: boolean) => void;
}

const LayoutSettingsModal: React.FC<LayoutSettingsModalProps> = ({
  isOpen,
  showClassMaterials,
  showAllLanguages,
  onClose,
  onSave,
}) => {
  const [tempShowClassMaterials, setTempShowClassMaterials] =
    useState(showClassMaterials);
  const [tempShowAllLanguages, setTempShowAllLanguages] =
    useState(showAllLanguages);

  // 모달 스크롤 방지 효과
  useEffect(() => {
    if (isOpen) {
      // 스크롤 위치 저장
      const scrollY = window.scrollY;

      // body에 modal-open 클래스 추가
      document.body.classList.add("modal-open");

      // 스크롤 위치 설정
      document.body.style.top = `-${scrollY}px`;

      // 정리 함수
      return () => {
        document.body.classList.remove("modal-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  // 모달이 열릴 때마다 설정 초기화
  useEffect(() => {
    if (isOpen) {
      setTempShowClassMaterials(showClassMaterials);
      setTempShowAllLanguages(showAllLanguages);
    }
  }, [isOpen, showClassMaterials, showAllLanguages]);

  const handleSave = () => {
    onSave(tempShowClassMaterials, tempShowAllLanguages);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>레이아웃 설정</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="settings-content">
            <div className="setting-group">
              <h4>화면 구성</h4>
              <div className="setting-item">
                <label className="setting-checkbox">
                  <input
                    type="checkbox"
                    checked={tempShowClassMaterials}
                    onChange={(e) =>
                      setTempShowClassMaterials(e.target.checked)
                    }
                  />
                  <span>강의 자료 표시</span>
                </label>
                <p className="setting-description">
                  {tempShowClassMaterials
                    ? "강의 자료와 번역 결과를 모두 표시합니다."
                    : "번역 결과만 전체 화면으로 표시합니다."}
                </p>
              </div>
            </div>

            <div className="setting-group">
              <h4>번역 결과 표시 방식</h4>
              <div className="setting-item">
                <label className="setting-checkbox">
                  <input
                    type="checkbox"
                    checked={tempShowAllLanguages}
                    onChange={(e) => setTempShowAllLanguages(e.target.checked)}
                  />
                  <span>모든 번역 언어 동시에 표시</span>
                </label>
                <p className="setting-description">
                  {tempShowAllLanguages
                    ? "설정된 모든 언어로 번역 결과를 동시에 표시합니다."
                    : "선택한 언어의 번역 결과만 표시합니다."}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            취소
          </button>
          <button className="btn-primary" onClick={handleSave}>
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default LayoutSettingsModal;
